import { DocumentAccountAssignmentEntity } from "@odata/GeneratedEntityTypes";
import { DocumentLinkTypeCode } from "@odata/GeneratedEnums";
import {
    creditAndDebitAccount,
    getDocumentFilterByUsedAccountNumber
} from "@pages/accountAssignment/AccountAssignment.utils";

const initialAccountBalancesNumbers = ["701", "702"];

export const getInitialBalancesAccountFilter = (): string => {
    const conditions = initialAccountBalancesNumbers.reduce((filters, account) => {
        filters.push(...(creditAndDebitAccount.map(type => getDocumentFilterByUsedAccountNumber(type, account))));
        return filters;
    }, []);

    return conditions.join(" OR ");
};

export const FUTURE_EXPENSES_ACCOUNT = "383";
export const FUTURE_REVENUES_ACCOUNT = "385";

export const ACCRUAL_ACCOUNT_ACTIVE = "388";
export const ACCRUAL_ACCOUNT_PASSIVE = "389";

export const CLOSING_ACCOUNTS_PREFIX = "7";

export const excludeInitialBalancesFilter = `not(${getInitialBalancesAccountFilter()})`;
export const getOpenAccrualFilter = (isOpen = true): string =>
        `DocumentLinks/${isOpen ? "all" : "any"}(link: link/TypeCode in ('${DocumentLinkTypeCode.EDR}', '${DocumentLinkTypeCode.EAE}')${isOpen ? " eq false" : ""})`;
export const accruedRevenueFilter = getDocumentFilterByUsedAccountNumber(DocumentAccountAssignmentEntity.DebitAccount, ACCRUAL_ACCOUNT_ACTIVE);
export const accruedExpenseFilter = getDocumentFilterByUsedAccountNumber(DocumentAccountAssignmentEntity.CreditAccount, ACCRUAL_ACCOUNT_PASSIVE);
